var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.521559 15.5079L0.501709 6.5155H7.2113L11.7175 2.00935L11.7373 20.014L7.23116 15.5079H0.521559ZM13.9209 20.8081V18.5054C15.6016 18.0157 16.9581 17.0764 17.9904 15.6873C19.0226 14.2983 19.5387 12.7298 19.5387 10.9819C19.5387 9.23401 19.0226 7.66606 17.9904 6.27808C16.9581 4.89011 15.6016 3.95024 13.9209 3.45847V1.15576C16.2369 1.67188 18.1293 2.84335 19.5983 4.67016C21.0672 6.49697 21.8017 8.6009 21.8017 10.9819C21.8017 13.3629 21.0672 15.4674 19.5983 17.2953C18.1293 19.1231 16.2369 20.2941 13.9209 20.8081ZM13.9209 16.1233V13.4236C14.2518 13.0927 14.5231 12.7224 14.7348 12.3127C14.9466 11.903 15.0524 11.4726 15.0524 11.0216C15.0524 10.5452 14.95 10.0987 14.7451 9.68211C14.5403 9.26551 14.2655 8.8849 13.9209 8.54029V5.84057C14.9002 6.36993 15.7075 7.08456 16.3427 7.98447C16.978 8.88437 17.2956 9.89015 17.2956 11.0017C17.2956 12.1134 16.978 13.1128 16.3427 14C15.7075 14.8872 14.9002 15.595 13.9209 16.1233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/volume-icon.73e3d62b012a2d2fbad7e3be56ad357f.svg";
export { ForwardRef as ReactComponent };